import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logoutUser } from '../actions/auth';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import config from '../config';
import loadingGif from '../assets/loading.gif';
import './Logout.css';

class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    this.handleLogout();
    // this.props.dispatch(logoutUser());
    // this.setState({ isLoading: false });
  }

  async handleLogout() {
    const baseUrl = getBaseUrlFromConfig(config.biztechApi);
    try {
      await axios.post(`${baseUrl}/default/logout`);
    } catch (error) {
      // console.error(error.message);
    }
    this.props.dispatch(logoutUser());
    this.setState({ isLoading: false });
  }

  redirectToHome() {
    window.location.href = getBaseUrlFromConfig(config.appSettings);
    return;
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="mt-100">
          <img src={loadingGif} alt="loading..." />
          <h1>Please wait...logging out...</h1>
        </div>
      );
    } else {
      return (
        <div className="mt-150">
          <h1>You have been successfully logged out!</h1>
          <Link className="fs-21" onClick={this.redirectToHome}>
            Login
          </Link>
        </div>
      );
    }
  }
}

export default connect(({ auth }) => ({ auth }))(Logout);
